export default __webpack_public_path__ + "32acb32.png";